import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function GamingBettingLicenseCyprus (){

    return (
        <main className='main'>

            <IntroSection
                title="Gaming & Betting License – Cyprus (National Betting Authority)"
                subtitle="Operate Regulated Sports Betting in the EU"
                description =
                    "
                    <b>Cyprus</b> offers a <b>Betting License</b> under the supervision of the <b>National Betting Authority (NBA)</b>. While it does not yet regulate online casinos or poker, Cyprus is a recognized <b>EU jurisdiction</b> for online and land-based <b>sports betting operations</b>.
                    <br/>
                    <br/>
                    A <b>Cyprus license</b> provides <b>EU credibility</b>, <b>banking access</b>, and <b>investor trust</b> — all at <b>lower costs</b> than Malta.
                    "

                badges={
                    [
                        "Online Sportsbook",
                        "Fixed-Odds Betting",
                        "Land-Based Betting Shops"
                    ]
                }
                buttonText="Request a Cyprus Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gaming-betting-license–cyprus-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for Gaming?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "EU Recognition", text: "fully licensed under an EU authority (NBA)" },
                                        { title: "Sports Betting Focus", text: "covers both online and land-based operations" },
                                        { title: "Banking & PSP Access", text: "higher acceptance than offshore gaming licenses" },
                                        { title: "Corporate Tax 12.5%", text: "one of the lowest in the EU" },
                                        { title: "Cost-Effective EU Entry", text: "cheaper than Malta, with solid recognition" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Gaming Licenses in Cyprus"
                        subtitle='Malta Gaming Authority (MGA) issues two main categories:'
                        blocks={[
                            {
                                title: "Class A License (Land-Based Betting)",
                                items:
                                    [
                                        { title: "Betting Shops Authorization", text: "Authorizes betting shops and other physical establishments" },
                                        { title: "Scope", text: "Covers fixed-odds betting only" },
                                        { title: "Exclusions", text: "Does not include casino games or slot machines" }
                                    ]
                            },
                            {
                                title: "Class B License (Online Betting)",
                                items: [
                                    { text: "Authorizes online sports betting platforms" },
                                    { text: "Covers pre-match & in-play betting" },
                                    { text: "Cannot offer casino games, poker, or lotteries" }
                                ]
                            },
                        ]}
                    />


                    <FeatureCards
                        title='Capital & Requirements'
                        features={
                            [
                                { title: "Minimum Capital", text: "€500,000" },
                                { title: "Bank Guarantee", text: "€550,000 required for NBA approval" },
                                { title: "Local Presence", text: "company incorporation in Cyprus required" },
                                { title: "Compliance", text: "AML/KYC systems, responsible gaming policies" },
                                { title: "Duration", text: "licenses are valid for 2 years, renewable" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Cyprus Betting License'
                        item={
                            [
                                { title: "EU Jurisdiction", text: "stronger reputation than offshore gaming centers" },
                                { title: "Banking Access", text: "easier onboarding with EU banks & PSPs" },
                                { title: "Player Trust", text: "regulated under EU AML and responsible gaming rules" },
                                { title: "Scalable", text: "start with sports betting, expand to Malta or offshore for casino" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Pre-Application Review", text: "define Class A or Class B license" },
                                { title: "Company Setup", text: "incorporate in Cyprus" },
                                { title: "Application Submission", text: "submit business plan, AML/KYC, capital proof" },
                                { title: "NBA Review", text: "fit & proper test for shareholders, directors" },
                                { title: "Approval & License Issuance", text: "typically 3–6 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from €80,000+ (legal, compliance, advisory)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "€500,000 minimum",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Bank Guarantee",
                                description: "€550,000",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Fees",
                                description: "NBA supervision + compliance reporting",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in EU betting & gaming licensing" },
                                { text: "End-to-end support: company setup, license filing, compliance" },
                                { text: "Introductions to PSPs, affiliate networks, and betting software providers" },
                                { text: "Comparison guidance: Cyprus vs Malta vs Offshore jurisdictions" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Looking to launch a regulated sportsbook in the EU?'
                         description=
                            "<b>Cyprus</b> offers <b>Class A & B betting licenses</b> with <b>EU recognition</b> and <b>banking access</b>, making it ideal for <b>sports betting operators</b>."
                         buttonText='Book a Cyprus Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I run an online casino in Cyprus?",
        content: [
            { type: "answer", text: "No — Cyprus only regulates sports betting. Casino, poker, and lotteries are not licensed." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "€500,000 + €550,000 bank guarantee." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 3–6 months." },
        ],
    },
    {
        question: "Can I operate across the EU with a Cyprus license?",
        content: [
            { type: "answer", text: "Not with full passporting like Malta MGA. Recognition is mainly local + limited EU credibility." },
        ],
    },
    {
        question: "What’s the best strategy for gaming?",
        content: [
            { type: "answer", text: "Use Cyprus for sports betting, and Malta/Curacao/Anjouan for casino & iGaming." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We licensed our sportsbook in Cyprus. Offshore Advisory managed NBA requirements and banking integration.",
            author: "George P.",
            role: "Sportsbook Operator"
        },
        {
            quote: "Cyprus was the right choice for regulated sports betting. Offshore Advisory made compliance clear and efficient.",
            author: "Sofia L.",
            role: "Gaming Entrepreneur"
        }
    ]
;